import { Card, CardBody, Skeleton } from '@heroui/react';
import React from 'react';

/**
 * Structural skeleton for the chat edit screen, shown while chat details
 * load. Mirrors the real layout (header, tab bar, two participant columns)
 * so a slow query reads as progress instead of a hung page.
 */
export const EditChatSkeleton: React.FC = () => {
  return (
    <div className="p-6 min-h-screen bg-background">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header: back button, title block, actions */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Skeleton className="w-9 h-9 rounded-lg" />
            <div className="space-y-2">
              <Skeleton className="w-64 h-6 rounded-lg" />
              <Skeleton className="w-40 h-4 rounded-lg" />
            </div>
          </div>
          <Skeleton className="w-28 h-9 rounded-lg" />
        </div>

        {/* Tab bar */}
        <div className="flex gap-6 border-b border-divider pb-3">
          <Skeleton className="w-28 h-5 rounded-lg" />
          <Skeleton className="w-20 h-5 rounded-lg" />
          <Skeleton className="w-24 h-5 rounded-lg" />
          <Skeleton className="w-28 h-5 rounded-lg" />
        </div>

        {/* Two participant columns */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {[0, 1].map((column) => (
            <Card key={column}>
              <CardBody className="p-6 space-y-6">
                <Skeleton className="w-32 h-5 rounded-lg" />
                <Skeleton className="w-full h-16 rounded-lg" />
                <Skeleton className="w-full h-14 rounded-lg" />
                <div className="space-y-3">
                  <Skeleton className="w-full h-20 rounded-lg" />
                  <Skeleton className="w-full h-20 rounded-lg" />
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};
